import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { LanguageDb } from '../redux/languageDbSlice';

const useAllLanguageDbs = (): [string[], LanguageDb[]] => {
  const languageDb = useSelector((state: RootState) => state.languageDb);
  const ids = Object.keys(languageDb.languages);
  const values = ids.map(id => languageDb.languages[id]);

  return [ids, values];
}

export default useAllLanguageDbs;
